import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { Switch, Route, BrowserRouter, useLocation } from "react-router-dom";

import Home from "./pages/home";
import Login from "./pages/login";
import Project from "./pages/project";
import Thought from "./pages/thought";
import ThoughtEditor from "./pages/thought-editor";
import Thoughts from "./pages/thoughts";
import About from "./pages/about";
import Cv from "./pages/cv";
import Hagah from "./pages/hagah";
import NotFound from "./pages/not-found";

import GlobalStyle from "./style";

import RouterList from "./data/project";
import ScrollToTop from "./components/common/scroll-to-top";
import MusicPlayer from "./components/global/music-player";

import { AuthenticationContext } from "./context/authentication-context";
import { ThemeContext, ThemeMode } from "./context/theme-context";
import { observeAuthentication } from "./data/firebase";

const RouteAwareMusicPlayer = () => {
  const location = useLocation();

  return location.pathname === "/hagah" ? null : <MusicPlayer />;
};

const App = () => {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isAuthenticationReady, setAuthenticationReady] = useState(false);
  const [theme, setTheme] = useState<ThemeMode>(() => {
    return window.localStorage.getItem("freddy-theme") === "dark"
      ? "dark"
      : "light";
  });

  useEffect(() => {
    const unsubscribe = observeAuthentication((authenticated) => {
      setLoggedIn(authenticated);
      setAuthenticationReady(true);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    window.localStorage.setItem("freddy-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) =>
      currentTheme === "light" ? "dark" : "light"
    );
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <AuthenticationContext.Provider
        value={{ isLoggedIn, isAuthenticationReady }} >
        <BrowserRouter>
          <ScrollToTop />
          <Switch>
            <Route exact path="/admin-on-freddy" component={ThoughtEditor} />
            <Route exact path="/thoughts/:slug" component={Thought} />
            <Route exact path="/thoughts" component={Thoughts} />
            <Route exact path="/about" component={About} />
            <Route exact path="/cv" component={Cv} />
            <Route exact path="/hagah" component={Hagah} />
            {RouterList.map((item) => (
              <Route
                key={item.url}
                path={item.url}
                render={() => <Project {...item.detail} />}
              />
            ))}

            <Route path="/login" component={Login} />
            <Route exact path="/" component={Home} />
            <Route component={NotFound} />
          </Switch>
          <RouteAwareMusicPlayer />
        </BrowserRouter>
      </AuthenticationContext.Provider>
    </ThemeContext.Provider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
